import React, { useEffect, useState, useRef } from 'react';
import { Plus, Pencil, Trash2, X, Check, Upload } from 'lucide-react';
import { noticiaService } from '../../services/api';
import toast from 'react-hot-toast';

const CATEGORIAS = ['noticias', 'eventos', 'projetos', 'educacao', 'saude', 'social'];

export default function AdminNoticias() {
  const [items,   setItems]   = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [modal,   setModal]   = useState<'criar'|'editar'|null>(null);
  const [current, setCurrent] = useState<any>(null);
  const [saving,  setSaving]  = useState(false);
  const [form, setForm] = useState({ titulo:'', subtitulo:'', conteudo:'', categoria:'noticias', destaque:'false', publicado:'true', autor:'', tags:'' });
  const [imgFile, setImgFile] = useState<File|null>(null);
  const [imgPrev, setImgPrev] = useState('');
  const fileRef = useRef<HTMLInputElement>(null);

  const load = () => {
    setLoading(true);
    noticiaService.listarAdmin()
      .then(r => setItems(r.data.noticias || []))
      .catch(() => toast.error('Erro ao carregar notícias'))
      .finally(() => setLoading(false));
  };
  useEffect(load, []);

  const openCriar = () => {
    setForm({ titulo:'', subtitulo:'', conteudo:'', categoria:'noticias', destaque:'false', publicado:'true', autor:'', tags:'' });
    setImgFile(null); setImgPrev(''); setCurrent(null); setModal('criar');
  };
  const openEditar = (item: any) => {
    setForm({ titulo: item.titulo, subtitulo: item.subtitulo||'', conteudo: item.conteudo||'', categoria: item.categoria||'noticias', destaque: String(item.destaque), publicado: String(item.publicado), autor: item.autor||'', tags: item.tags?.join(', ')||'' });
    setImgPrev(item.imagemUrl||''); setImgFile(null); setCurrent(item); setModal('editar');
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) =>
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const onFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const f = e.target.files?.[0];
    if (f) { setImgFile(f); setImgPrev(URL.createObjectURL(f)); }
  };

  const salvar = async () => {
    setSaving(true);
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k,v]) => fd.append(k, v));
      if (imgFile) fd.append('imagem', imgFile);
      if (modal === 'criar') await noticiaService.criar(fd);
      else await noticiaService.atualizar(current._id, fd);
      toast.success(modal === 'criar' ? 'Notícia criada!' : 'Notícia atualizada!');
      setModal(null); load();
    } catch { toast.error('Erro ao salvar.'); }
    finally { setSaving(false); }
  };

  const deletar = async (id: string) => {
    if (!window.confirm('Deseja excluir esta notícia?')) return;
    try { await noticiaService.deletar(id); toast.success('Excluída!'); load(); }
    catch { toast.error('Erro ao excluir.'); }
  };

  return (
    <div>
      <div className="admin-page-header">
        <h1>Notícias</h1>
        <button className="btn btn-primary" onClick={openCriar}><Plus size={17}/> Nova notícia</button>
      </div>

      {loading ? (
        <div className="loading-center"><div className="spinner"/></div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table className="admin-table">
            <thead><tr>
              <th>Imagem</th><th>Título</th><th>Categoria</th>
              <th>Publicado</th><th>Destaque</th><th>Data</th><th>Ações</th>
            </tr></thead>
            <tbody>
              {items.length === 0 && (
                <tr><td colSpan={7} style={{ textAlign:'center', color:'var(--texto-leve)', padding:32 }}>Nenhuma notícia.</td></tr>
              )}
              {items.map(item => (
                <tr key={item._id}>
                  <td>
                    {item.imagemUrl
                      ? <img src={item.imagemUrl} alt="" style={{ width:52, height:40, objectFit:'cover', borderRadius:6 }} />
                      : <div style={{ width:52, height:40, background:'var(--creme-escuro)', borderRadius:6 }}/>
                    }
                  </td>
                  <td style={{ maxWidth:220, fontWeight:600, fontSize:'0.9rem' }}>{item.titulo}</td>
                  <td><span className="badge badge-laranja">{item.categoria}</span></td>
                  <td>{item.publicado ? <Check size={16} color="#16a34a"/> : <X size={16} color="#dc2626"/>}</td>
                  <td>{item.destaque  ? <Check size={16} color="#16a34a"/> : <X size={16} color="#dc2626"/>}</td>
                  <td style={{ fontSize:'0.82rem', color:'var(--texto-leve)' }}>{new Date(item.criadoEm).toLocaleDateString('pt-BR')}</td>
                  <td>
                    <div className="actions">
                      <button className="btn btn-outline btn-sm" onClick={() => openEditar(item)}><Pencil size={14}/></button>
                      <button className="btn btn-sm" style={{ background:'#fee2e2',color:'#b91c1c',borderRadius:'var(--radius)' }} onClick={() => deletar(item._id)}><Trash2 size={14}/></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Modal */}
      {modal && (
        <div className="admin-modal-overlay" onClick={() => setModal(null)}>
          <div className="admin-modal" onClick={e => e.stopPropagation()}>
            <div className="admin-modal-header">
              <h3>{modal === 'criar' ? 'Nova Notícia' : 'Editar Notícia'}</h3>
              <button className="modal-close" onClick={() => setModal(null)}><X size={20}/></button>
            </div>
            <div className="admin-modal-body">
              {/* Imagem */}
              <div className="form-group">
                <label className="form-label">Imagem</label>
                <div className="img-upload-area" onClick={() => fileRef.current?.click()}>
                  {imgPrev
                    ? <img src={imgPrev} alt="preview" style={{ width:'100%', height:'100%', objectFit:'cover', borderRadius:'var(--radius)' }} />
                    : <div className="img-upload-placeholder"><Upload size={24}/><span>Clique para enviar</span></div>
                  }
                </div>
                <input ref={fileRef} type="file" accept="image/*" style={{ display:'none' }} onChange={onFile}/>
              </div>
              <div className="form-row-2">
                <div className="form-group">
                  <label className="form-label">Título *</label>
                  <input name="titulo" value={form.titulo} onChange={onChange} className="form-control" required/>
                </div>
                <div className="form-group">
                  <label className="form-label">Categoria</label>
                  <select name="categoria" value={form.categoria} onChange={onChange} className="form-control">
                    {CATEGORIAS.map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
              </div>
              <div className="form-group">
                <label className="form-label">Subtítulo</label>
                <input name="subtitulo" value={form.subtitulo} onChange={onChange} className="form-control"/>
              </div>
              <div className="form-group">
                <label className="form-label">Conteúdo *</label>
                <textarea name="conteudo" value={form.conteudo} onChange={onChange} className="form-control" rows={6} required/>
              </div>
              <div className="form-row-2">
                <div className="form-group">
                  <label className="form-label">Autor</label>
                  <input name="autor" value={form.autor} onChange={onChange} className="form-control" placeholder="Nome do autor"/>
                </div>
                <div className="form-group">
                  <label className="form-label">Tags (separadas por vírgula)</label>
                  <input name="tags" value={form.tags} onChange={onChange} className="form-control" placeholder="saude, educação"/>
                </div>
              </div>
              <div className="form-row-2">
                <div className="form-group">
                  <label className="form-label">Publicado</label>
                  <select name="publicado" value={form.publicado} onChange={onChange} className="form-control">
                    <option value="true">Sim</option><option value="false">Não</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Destaque</label>
                  <select name="destaque" value={form.destaque} onChange={onChange} className="form-control">
                    <option value="false">Não</option><option value="true">Sim</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="admin-modal-footer">
              <button className="btn btn-outline" onClick={() => setModal(null)}>Cancelar</button>
              <button className="btn btn-primary" onClick={salvar} disabled={saving}>
                {saving ? 'Salvando…' : <><Check size={16}/> Salvar</>}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
